import { request } from "@/utils/request";
export function login(username, password) {
  return request({
    url: `/sys/login`,
    method: "post",
    data: {
      username,
      password,
      thirdType: "wechat_open",
      loginSource: "hm-service"
    }
  });
}

export function wxlogin(username, password, thirdUserUuid, thirdType) {
  return new Promise((resolve, reject) => {
    request({
      url: `/sys/thirdLogin/bindingThirdAccount`,
      method: "post",
      data: {
        username,
        password,
        thirdUserUuid,
        thirdType
      }
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function userInfoByToken(token, thirdType) {
  return request({
    url: `sys/thirdLogin/getLoginUserInfo`,
    method: "post",
    data: {
      token,
      thirdType
    }
  });
}

export function logout(logoutToken) {
  return request({
    url: `/sys/logout`,
    method: "post",
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      "X-Access-Token": logoutToken
    }
  });
}
